
<div class="container">
		<user-list *ngIf="!(activeUser$ | async)"></user-list>
		
		<user-details *ngIf="activeUser$ | async" [user]="(activeUser$ | async)"></user-details>
	</div>
	